import React from 'react';
import { Phone, MessageSquare, Users, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const AIAgents = () => {
  const { t } = useLanguage();

  const agents = [
    {
      icon: <Phone className="w-16 h-16 text-green-400" />,
      title: t.services.speedToLead.title,
      subtitle: t.services.speedToLead.subtitle,
      description: t.services.speedToLead.description,
      features: [
        'Llamadas automáticas en menos de 1 minuto',
        'Integración con CRM en tiempo real',
        'Respuestas naturales con IA',
        'Disponibilidad 24/7',
        'Calificación automática de leads'
      ],
      gradient: 'from-green-600/20 to-emerald-600/20'
    },
    {
      icon: <MessageSquare className="w-16 h-16 text-green-400" />,
      title: t.services.textAgent.title,
      subtitle: t.services.textAgent.subtitle,
      description: t.services.textAgent.description,
      features: [
        'Conversaciones personalizadas',
        'Seguimiento automático',
        'Múltiples canales (SMS, WhatsApp, Email)',
        'Análisis de sentimiento',
        'Respuestas contextuales'
      ],
      gradient: 'from-green-500/20 to-teal-600/20'
    },
    {
      icon: <Users className="w-16 h-16 text-green-400" />,
      title: t.services.recovery.title,
      subtitle: t.services.recovery.subtitle,
      description: t.services.recovery.description,
      features: [
        'Recuperación inteligente de leads',
        'Campañas de reactivación',
        'Llamadas y mensajes automatizados',
        'Segmentación avanzada',
        'Reporting detallado'
      ],
      gradient: 'from-emerald-600/20 to-green-500/20'
    }
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-900/20 via-black to-emerald-900/20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="bg-green-600/20 text-green-400 border-green-600/30 mb-6 px-4 py-2">
              {t.team.badge}
            </Badge>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                Agentes IA
              </span>{' '}
              de GERVIS
            </h1>
            <p className="text-xl text-gray-200">
              {t.team.title}
            </p>
          </div>
        </div>
      </section>

      {/* Agents Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="space-y-20">
            {agents.map((agent, index) => (
              <div 
                key={index} 
                className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-12 items-center max-w-6xl mx-auto`}
              >
                <div className="flex-1">
                  <Card className="bg-gradient-to-br from-gray-900 to-black border-green-900/30 hover:border-green-600/50 transition-all duration-300">
                    <CardContent className="p-12">
                      <div className={`w-24 h-24 rounded-2xl bg-gradient-to-br ${agent.gradient} flex items-center justify-center mb-6`}>
                        {agent.icon}
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <div className="flex-1 space-y-6">
                  <Badge className="bg-green-600/20 text-green-400 border-green-600/30">
                    {agent.subtitle}
                  </Badge>
                  <h2 className="text-3xl md:text-4xl font-bold">{agent.title}</h2>
                  <p className="text-xl text-gray-200">{agent.description}</p>
                  <ul className="space-y-3">
                    {agent.features.map((feature, fIndex) => (
                      <li key={fIndex} className="flex items-start space-x-3">
                        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                        <span className="text-gray-200">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIAgents;